module.exports = __webpack_public_path__ + "img/loading.356dcb15.gif";